function s(n, a) {
  return n != null && a in Object(n);
}
var e = s;
export {
  e as _
};
